import { ReactElement } from "react";
import {
    CookieConsent,
    CookieConsentDialog
} from "@idwal/idwal-react-components";
import { cookiePreferences } from "@idwal/idwal-utilities";
import {
    COOKIE_POLICY_LINK,
    DATA_PRIVACY_EMAIL
} from "../../constants/CookiePolicy";

interface CookiePolicyProps {
    cookieUtils: ReturnType<typeof cookiePreferences>;
    dialogVisible: boolean;
    onShowDialog: () => void;
    onHideDialog: () => void;
}

/**
 * The consent banner and preferences dialog shared with the other Idwal apps.
 * The library only offers these bundled with its own footer, which lacks the
 * report licensing details buyers-app shows, so they are rendered here and
 * the dialog is opened from the buyers-app footer instead.
 */
export const CookiePolicy = ({
    cookieUtils,
    dialogVisible,
    onShowDialog,
    onHideDialog
}: CookiePolicyProps): ReactElement => {
    const preferences = cookieUtils.readCookiePreferences();

    // The banner stays up until a choice has been stored, so that is what
    // decides whether it shows rather than any local state.
    const noPreferencesStored =
        preferences?.all === undefined &&
        preferences?.nonEssential === undefined &&
        preferences?.analytics === undefined;

    const analyticsEnabled = Boolean(preferences?.analytics);

    return (
        <>
            <CookieConsentDialog
                onToggleAnalyticsCookies={() =>
                    cookieUtils.acceptAnalytics(!analyticsEnabled)
                }
                analyticCookiesEnabled={analyticsEnabled}
                visible={dialogVisible}
                dataPrivacyLink={DATA_PRIVACY_EMAIL}
                cookiePolicyLink={COOKIE_POLICY_LINK}
                onHide={onHideDialog}
            />
            <CookieConsent
                onClickCookiePolicy={onShowDialog}
                onReject={cookieUtils.rejectAll}
                onAccept={cookieUtils.acceptAll}
                onHide={() => undefined}
                visible={noPreferencesStored}
            />
        </>
    );
};
